import React from 'react';
import imageLoader, { STATUS } from 'utils/imageLoader';

// Bridges the shared imageLoader queue to component state.
// `enabled: false` keeps the URL out of the queue (used by lazy thumbnails).
export default (url, { priority = 0, enabled = true } = {}) => {
  const [status, setStatus] = React.useState(() =>
    url ? imageLoader.getStatus(url) : STATUS.idle
  );
  const mountedRef = React.useRef(true);

  React.useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const track = React.useCallback((promise) => {
    promise
      .then(() => mountedRef.current && setStatus(STATUS.loaded))
      .catch((error) => mountedRef.current && !error.canceled && setStatus(STATUS.error));
  }, []);

  React.useEffect(() => {
    if (!enabled || !url) return;
    setStatus(imageLoader.getStatus(url));
    track(imageLoader.load(url, { priority }));
  }, [url, enabled, priority, track]);

  const retry = React.useCallback(() => {
    setStatus(STATUS.queued);
    track(imageLoader.retry(url));
  }, [url, track]);

  return { status, retry };
};
